import React from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import { getJobSettingsState } from '../../../../store/selectors'
import { hangerActions } from '../../../../store/slices'

import { Accordion } from '../../../../../../components'
import { TopFlangeOptions, SASCalculator, AngleOptions } from './components'

import { CONNECTION_TYPE, HANGER_TYPE } from '../../../../common/constants'
import { useCalcActions } from '../../../../common/hooks'
import { RenderIf } from '../../../../../../utils/fns'

const HangerOptions = ({ connectionType }) => {
  const hangerType = useSelector((state) => getJobSettingsState(state).hangerType)

  const { errors, validateField, updateCalcValue } = useCalcActions(hangerActions)

  return (
    <Accordion title="Hanger Options">
      <div className="space-y-3">
        {RenderIf(
          connectionType === CONNECTION_TYPE.JOIST,
          <SASCalculator hangerType={hangerType} onChange={updateCalcValue} />,
        )}
        <AngleOptions
          hangerType={hangerType}
          onChange={updateCalcValue}
          onValidateField={validateField}
          errors={errors}
        />
        {RenderIf(
          hangerType === HANGER_TYPE.ALL_TYPES || hangerType === HANGER_TYPE.TOP_FLANGE,
          <TopFlangeOptions
            hangerType={hangerType}
            onChange={updateCalcValue}
            onValidateField={validateField}
            errors={errors}
          />,
        )}
      </div>
    </Accordion>
  )
}

HangerOptions.propTypes = {
  connectionType: PropTypes.string.isRequired,
}

export default HangerOptions
